export const coords = [
  { lng: -58.455350887999941, lat: -34.52776287599994 },
  { lng: -58.454035573999931, lat: -34.529295216999969 },
  { lng: -58.452775187999976, lat: -34.530760996999959 },
  { lng: -58.452548630999956, lat: -34.531024474999981 },
  { lng: -58.452309265999986, lat: -34.531302846999949 },
  { lng: -58.452001134999932, lat: -34.531757957999957 },
  { lng: -58.451784148999934, lat: -34.531536307999943 },
  { lng: -58.451695364999978, lat: -34.531445614999939 },
  { lng: -58.451550691999955, lat: -34.53149383799996 },
  { lng: -58.451438382999982, lat: -34.531531273999974 },
  { lng: -58.450853035999955, lat: -34.532302220999952 },
  { lng: -58.450701311999978, lat: -34.532636010999965 },
  { lng: -58.450647832999948, lat: -34.532753664999973 },
  { lng: -58.450353348999954, lat: -34.533401530999981 },
  { lng: -58.450137896999934, lat: -34.53406873299997 },
  { lng: -58.45006727599997, lat: -34.534287434999953 },
  { lng: -58.449910768999985, lat: -34.53477210099993 },
  { lng: -58.449945280999941, lat: -34.535112998999978 },
  { lng: -58.449577657999953, lat: -34.535264372999961 },
  { lng: -58.449123161999978, lat: -34.535451518999935 },
  { lng: -58.448974460999978, lat: -34.535512747999974 },
  { lng: -58.448904035999988, lat: -34.535544976999972 },
  { lng: -58.448860246999971, lat: -34.535605547999978 },
  { lng: -58.448803139999939, lat: -34.535691207999946 },
  { lng: -58.448789975999944, lat: -34.53574472899993 },
  { lng: -58.448867476999965, lat: -34.535873894999952 },
  { lng: -58.44900301399997, lat: -34.535962466999933 },
  { lng: -58.44914578199996, lat: -34.536055264999959 },
  { lng: -58.449281410999959, lat: -34.536133787999972 },
  { lng: -58.449338517999934, lat: -34.536162340999965 },
  { lng: -58.449381348999964, lat: -34.536290832999953 },
  { lng: -58.449338517999934, lat: -34.536383631999968 },
  { lng: -58.44929568799995, lat: -34.536469291999936 },
  { lng: -58.449238580999975, lat: -34.536533536999968 },
  { lng: -58.44915292, lat: -34.536669166999957 },
  { lng: -58.449102951999976, lat: -34.536747687999934 },
  { lng: -58.449031567999953, lat: -34.536854763999941 },
  { lng: -58.448967322999977, lat: -34.536940424999955 },
  { lng: -58.448874523999962, lat: -34.537011808999978 },
  { lng: -58.448810277999939, lat: -34.537076053999954 },
  { lng: -58.448753170999964, lat: -34.537147437999977 },
  { lng: -58.448724617999972, lat: -34.537204545999941 },
  { lng: -58.44871034099998, lat: -34.537261652999973 },
  { lng: -58.448681786999941, lat: -34.537340173999951 },
  { lng: -58.448638956999957, lat: -34.537368727999933 },
  { lng: -58.448539019999942, lat: -34.537368727999933 },
  { lng: -58.448410528999943, lat: -34.537311620999958 },
  { lng: -58.448289175999946, lat: -34.537261652999973 },
  { lng: -58.448153546999947, lat: -34.537204545999941 },
  { lng: -58.448107314999959, lat: -34.537181429999976 },
  { lng: -58.447982225999965, lat: -34.537118884999984 },
  { lng: -58.447946533999982, lat: -34.537068914999963 },
  { lng: -58.447982225999965, lat: -34.537011808999978 },
  { lng: -58.448089300999982, lat: -34.537011808999978 },
  { lng: -58.44821779199998, lat: -34.537004670999977 },
  { lng: -58.448232068999971, lat: -34.53689045699997 },
  { lng: -58.448196376999931, lat: -34.536833349999938 },
  { lng: -58.448046470999941, lat: -34.536719135999931 },
  { lng: -58.447939394999935, lat: -34.536633474999974 },
  { lng: -58.447789488999945, lat: -34.536519260999967 },
  { lng: -58.447575337999979, lat: -34.536433598999963 },
  { lng: -58.447418292999942, lat: -34.536340800999938 },
  { lng: -58.447318355999982, lat: -34.536297970999954 },
  { lng: -58.447211279999976, lat: -34.536262277999981 },
  { lng: -58.44696143699997, lat: -34.536183756999947 },
  { lng: -58.446768700999939, lat: -34.536112371999934 },
  { lng: -58.446597378999968, lat: -34.536048126999958 },
  { lng: -58.446589433999975, lat: -34.536045857999966 },
  { lng: -58.446447472999978, lat: -34.536005295999985 },
  { lng: -58.446340397999961, lat: -34.535976743999981 },
  { lng: -58.44614052299994, lat: -34.535941050999952 },
  { lng: -58.445919232999984, lat: -34.535933912999951 },
  { lng: -58.445705081999961, lat: -34.53592677499995 },
  { lng: -58.44554089899998, lat: -34.53592677499995 },
  { lng: -58.445441500999948, lat: -34.53594097499996 },
  { lng: -58.445341022999969, lat: -34.535955328999933 },
  { lng: -58.445198255999969, lat: -34.535969604999934 },
  { lng: -58.444998381999937, lat: -34.536012435999965 },
  { lng: -58.444762814999933, lat: -34.536040988999957 },
  { lng: -58.44457721699996, lat: -34.53607668099994 },
  { lng: -58.444441587999961, lat: -34.536098095999932 },
  { lng: -58.444163190999973, lat: -34.536140925999973 },
  { lng: -58.444041837999976, lat: -34.536162340999965 },
  { lng: -58.443849101999945, lat: -34.536226586999931 },
  { lng: -58.443511901999955, lat: -34.536391042999981 },
  { lng: -58.443394461999958, lat: -34.536448318999931 },
  { lng: -58.442946015999951, lat: -34.536667031999968 },
  { lng: -58.442586787999971, lat: -34.53684223099998 },
  { lng: -58.441548222999984, lat: -34.53794570499997 },
  { lng: -58.44153356299995, lat: -34.537961283999948 },
  { lng: -58.441444646999969, lat: -34.538055756999938 },
  { lng: -58.441135679999945, lat: -34.538553537999974 },
  { lng: -58.441019606999987, lat: -34.53874054399995 },
  { lng: -58.440930682999976, lat: -34.538883808999969 },
  { lng: -58.440901645999986, lat: -34.539156762999937 },
  { lng: -58.440859299999943, lat: -34.539554817999942 },
  { lng: -58.440857938999955, lat: -34.539624190999973 },
  { lng: -58.440853360999938, lat: -34.539857642999948 },
  { lng: -58.440843842999982, lat: -34.539867160999961 },
  { lng: -58.440765319999969, lat: -34.539895715999933 },
  { lng: -58.440573321999977, lat: -34.53989940799994 },
  { lng: -58.440394123999965, lat: -34.539902853999934 },
  { lng: -58.440351293999981, lat: -34.539845746999958 },
  { lng: -58.440338173999976, lat: -34.539819505999958 },
  { lng: -58.440329878999933, lat: -34.539802916999975 },
  { lng: -58.440237078999985, lat: -34.539781501999983 },
  { lng: -58.4401514199999, lat: -34.539781501999983 },
  { lng: -58.440058620999935, lat: -34.539824331999966 },
  { lng: -58.439880160999962, lat: -34.539938545999973 },
  { lng: -58.439701699999944, lat: -34.539981375999957 },
  { lng: -58.439606934999972, lat: -34.539981375999957 },
  { lng: -58.439508964999959, lat: -34.539981375999957 },
  { lng: -58.439423303999945, lat: -34.539995652999949 },
  { lng: -58.439344781999978, lat: -34.540031343999942 },
  { lng: -58.439144907999946, lat: -34.54005276 },
  { lng: -58.438966447999974, lat: -34.539995652999949 },
  { lng: -58.438680912999985, lat: -34.539909992999981 },
  { lng: -58.438359683999977, lat: -34.539888577999932 },
  { lng: -58.438067011999976, lat: -34.539874299999951 },
  { lng: -58.43781003, lat: -34.539909992999981 },
  { lng: -58.437724368999966, lat: -34.539909992999981 },
  { lng: -58.437667261999934, lat: -34.539831470999957 },
  { lng: -58.437586375999956, lat: -34.539808358999949 },
  { lng: -58.437567324999975, lat: -34.539802916999975 },
  { lng: -58.437547191999954, lat: -34.53981801499998 },
  { lng: -58.437510217999943, lat: -34.539845746999958 },
  { lng: -58.437388864999946, lat: -34.539931407999973 },
  { lng: -58.437296065999988, lat: -34.539974236999967 },
  { lng: -58.437074775999974, lat: -34.540017067999941 },
  { lng: -58.43683921, lat: -34.540095590999954 },
  { lng: -58.436582226999974, lat: -34.540174112999978 },
  { lng: -58.436479538999947, lat: -34.54022260499994 },
  { lng: -58.436325245999967, lat: -34.540295463999939 },
  { lng: -58.436032572999977, lat: -34.540452508999977 },
  { lng: -58.435511470999984, lat: -34.540880811999955 },
  { lng: -58.435418671999969, lat: -34.54098075 },
  { lng: -58.435290179999981, lat: -34.541166346999944 },
  { lng: -58.435175966999964, lat: -34.541337668999972 },
  { lng: -58.43509744399995, lat: -34.541523266999945 },
  { lng: -58.435004644999935, lat: -34.541723141999967 },
  { lng: -58.434926122999968, lat: -34.541880185999958 },
  { lng: -58.434847600999944, lat: -34.542087199999969 },
  { lng: -58.434811908999961, lat: -34.542215689999978 },
  { lng: -58.434769078999977, lat: -34.542315627999983 },
  { lng: -58.434690556999954, lat: -34.542436979999934 },
  { lng: -58.434576341999957, lat: -34.542572609999979 },
  { lng: -58.434355052999933, lat: -34.542751068999962 },
  { lng: -58.434148038999979, lat: -34.542879558999971 },
  { lng: -58.433955302999948, lat: -34.542986634999977 },
  { lng: -58.433762566999974, lat: -34.543086571999936 },
  { lng: -58.433434200999955, lat: -34.543243616999973 },
  { lng: -58.432970205999936, lat: -34.543486322999968 },
  { lng: -58.432648978999964, lat: -34.543671920999941 },
  { lng: -58.432349166999984, lat: -34.543857518999971 },
  { lng: -58.432184983999946, lat: -34.543964593999931 },
  { lng: -58.43192800199995, lat: -34.544178745999943 },
  { lng: -58.431563944999937, lat: -34.544507110999973 },
  { lng: -58.431456868999987, lat: -34.544607048999978 },
  { lng: -58.431356931999971, lat: -34.54477837 },
  { lng: -58.431221301999983, lat: -34.544971104999945 },
  { lng: -58.431114226999966, lat: -34.545178118999956 },
  { lng: -58.430964320999976, lat: -34.54551362199993 },
  { lng: -58.430864382999971, lat: -34.545841988999939 },
  { lng: -58.430828690999931, lat: -34.545977617999938 },
  { lng: -58.430792998999948, lat: -34.546091831999945 },
  { lng: -58.430757306999965, lat: -34.546241737999935 },
  { lng: -58.430714476999981, lat: -34.546441612999956 },
  { lng: -58.430685923999931, lat: -34.546612933999938 },
  { lng: -58.430708799999934, lat: -34.546945232999974 },
  { lng: -58.430728753999972, lat: -34.547169727999972 },
  { lng: -58.430684525999936, lat: -34.547867178999979 },
  { lng: -58.429968135999957, lat: -34.548272519999955 },
  { lng: -58.429610652999941, lat: -34.548883501999967 },
  { lng: -58.429034129999934, lat: -34.54920485599996 },
  { lng: -58.428654322999932, lat: -34.549185158999933 },
  { lng: -58.428425553999944, lat: -34.549396817999934 },
  { lng: -58.428046858999949, lat: -34.549319827999966 },
  { lng: -58.427629991999936, lat: -34.549428538999962 },
  { lng: -58.427411742999936, lat: -34.54896882099996 },
  { lng: -58.427252360999944, lat: -34.548633095999946 },
  { lng: -58.427202392999959, lat: -34.548618819999945 },
  { lng: -58.427145285999984, lat: -34.54853315899993 },
  { lng: -58.426938272999962, lat: -34.548247622999952 },
  { lng: -58.42690971899998, lat: -34.548190515999977 },
  { lng: -58.426831196999956, lat: -34.548140546999946 },
  { lng: -58.42675855899995, lat: -34.548169854999969 },
  { lng: -58.426609906999943, lat: -34.548190515999977 },
  { lng: -58.426527315999977, lat: -34.548235883999951 },
  { lng: -58.426103080999951, lat: -34.548468912999965 },
  { lng: -58.425623729999984, lat: -34.548779081999953 },
  { lng: -58.425617671999987, lat: -34.548783001999936 },
  { lng: -58.425553425999965, lat: -34.548832970999968 },
  { lng: -58.425546287999964, lat: -34.548868662999951 },
  { lng: -58.425560564999955, lat: -34.548982877999947 },
  { lng: -58.425603394999939, lat: -34.549054259999934 },
  { lng: -58.425596256999938, lat: -34.549125644999947 },
  { lng: -58.425439211999958, lat: -34.549168473999941 },
  { lng: -58.425346412999943, lat: -34.549182751999979 },
  { lng: -58.425197696999987, lat: -34.548944209999945 },
  { lng: -58.424750357999983, lat: -34.549020352999946 },
  { lng: -58.424438169999974, lat: -34.54916275599993 },
  { lng: -58.424207840999941, lat: -34.549267817999976 },
  { lng: -58.424438513999974, lat: -34.549700095999981 },
  { lng: -58.424939524999957, lat: -34.550638981999953 },
  { lng: -58.425604704999955, lat: -34.552265125999952 },
  { lng: -58.423124362999943, lat: -34.552928533999932 },
  { lng: -58.423090683999988, lat: -34.552937541999938 },
  { lng: -58.422947915999941, lat: -34.552987508999934 },
  { lng: -58.422919362999949, lat: -34.552980370999933 },
  { lng: -58.422862255999974, lat: -34.552873294999984 },
  { lng: -58.422326876999932, lat: -34.55299464899997 },
  { lng: -58.422362568999972, lat: -34.553130277999969 },
  { lng: -58.420881126999973, lat: -34.553521848999935 },
  { lng: -58.42074215599996, lat: -34.553558580999947 },
  { lng: -58.419778473999941, lat: -34.55377273299996 },
  { lng: -58.419185988999971, lat: -34.553944052999952 },
  { lng: -58.419063927999957, lat: -34.553975024999943 },
  { lng: -58.418707716999961, lat: -34.55406540599995 },
  { lng: -58.418186614999968, lat: -34.554193896999948 },
  { lng: -58.417601267999942, lat: -34.554336664999937 },
  { lng: -58.417251486999987, lat: -34.554422324999962 },
  { lng: -58.417001642999935, lat: -34.554486569999938 },
  { lng: -58.41665186299997, lat: -34.554565092999951 },
  { lng: -58.416244974999984, lat: -34.554700720999961 },
  { lng: -58.41601654699997, lat: -34.554779244999963 },
  { lng: -58.415738149999981, lat: -34.554872043999978 },
  { lng: -58.415416920999974, lat: -34.554993395999929 },
  { lng: -58.415245600999981, lat: -34.55504336499996 },
  { lng: -58.414974342999983, lat: -34.555157578999967 },
  { lng: -58.414660252999965, lat: -34.555278930999975 },
  { lng: -58.414453240999933, lat: -34.555364591999933 },
  { lng: -58.414203396999937, lat: -34.55552163599998 },
  { lng: -58.41397496899998, lat: -34.555657264999979 },
  { lng: -58.413800024999944, lat: -34.555772072999957 },
  { lng: -58.413746539999977, lat: -34.555807171999959 },
  { lng: -58.413638021999986, lat: -34.555847865999965 },
  { lng: -58.413518111999963, lat: -34.555892831999984 },
  { lng: -58.413444476999985, lat: -34.555938415999947 },
  { lng: -58.413368205999973, lat: -34.555985629999952 },
  { lng: -58.41315405499995, lat: -34.556106983999939 },
  { lng: -58.412968456999977, lat: -34.556206919999966 },
  { lng: -58.412747166999964, lat: -34.556321134999962 },
  { lng: -58.41252587699995, lat: -34.55645676499995 },
  { lng: -58.412176095999939, lat: -34.556670915999973 },
  { lng: -58.411976221999964, lat: -34.55678513 },
  { lng: -58.411719239999968, lat: -34.556956449999973 },
  { lng: -58.411412288999941, lat: -34.557177739999929 },
  { lng: -58.411226691999957, lat: -34.557320508999965 },
  { lng: -58.411141030999943, lat: -34.557384752999951 },
  { lng: -58.410983986999952, lat: -34.557399030999932 },
  { lng: -58.410869771999955, lat: -34.557334784999966 },
  { lng: -58.41076983499994, lat: -34.557256262999942 },
  { lng: -58.410723132999976, lat: -34.557211591999931 },
  { lng: -58.410605651999958, lat: -34.557099218999952 },
  { lng: -58.41032725499997, lat: -34.556856513999946 },
  { lng: -58.410163071999932, lat: -34.556699469999955 },
  { lng: -58.410013165999942, lat: -34.556635222999944 },
  { lng: -58.409877536999943, lat: -34.556578115999969 },
  { lng: -58.409756184999935, lat: -34.556570977999968 },
  { lng: -58.409670523999978, lat: -34.556578115999969 },
  { lng: -58.409577724999963, lat: -34.556613808999941 },
  { lng: -58.409434956999974, lat: -34.556678053999974 },
  { lng: -58.409406403999981, lat: -34.55674229899995 },
  { lng: -58.409370711999941, lat: -34.556806544999972 },
  { lng: -58.409370711999941, lat: -34.556899342999941 },
  { lng: -58.409384988999932, lat: -34.557013556999948 },
  { lng: -58.409413541999982, lat: -34.55707780399996 },
  { lng: -58.409577724999963, lat: -34.557277677999934 },
  { lng: -58.409898951999935, lat: -34.557548935999932 },
  { lng: -58.410077411999964, lat: -34.557684565999978 },
  { lng: -58.410170210999979, lat: -34.557741672999953 },
  { lng: -58.410171572999957, lat: -34.557750301999931 },
  { lng: -58.410191625999971, lat: -34.557877302999941 },
  { lng: -58.410170210999979, lat: -34.558020069999941 },
  { lng: -58.410127380999938, lat: -34.558127145999947 },
  { lng: -58.410063134999973, lat: -34.558205667999971 },
  { lng: -58.409293694999974, lat: -34.558828213999959 },
  { lng: -58.404567759999964, lat: -34.562940159999982 },
  { lng: -58.403654046999975, lat: -34.563753935999955 },
  { lng: -58.403140083999972, lat: -34.563939533999928 },
  { lng: -58.402269200999967, lat: -34.563839596999969 },
  { lng: -58.401569638999945, lat: -34.563425569999936 },
  { lng: -58.401241273999972, lat: -34.563325632999977 },
  { lng: -58.400770140999953, lat: -34.563354186999959 },
  { lng: -58.400091244999942, lat: -34.563492192999945 },
  { lng: -58.399198515999956, lat: -34.563673668999968 },
  { lng: -58.399027194999974, lat: -34.56370222299995 },
  { lng: -58.398770212999978, lat: -34.563823574999958 },
  { lng: -58.398548922999964, lat: -34.563937788999965 },
  { lng: -58.398420431999966, lat: -34.564023450999969 },
  { lng: -58.398291941999958, lat: -34.564137664999976 },
  { lng: -58.398106343999984, lat: -34.564294708999967 },
  { lng: -58.397984990999987, lat: -34.564394645999982 },
  { lng: -58.397813669999948, lat: -34.564551690999963 },
  { lng: -58.397720870999933, lat: -34.56463021299993 },
  { lng: -58.397563825999953, lat: -34.564715873999944 },
  { lng: -58.39737822799998, lat: -34.564837225999952 },
  { lng: -58.397242598999981, lat: -34.564930024999967 },
  { lng: -58.397149799999966, lat: -34.56495857799996 },
  { lng: -58.397042723999959, lat: -34.565008546999934 },
  { lng: -58.396957063999935, lat: -34.565058515999965 },
  { lng: -58.396885679999968, lat: -34.565101345999949 },
  { lng: -58.396835710999937, lat: -34.565122760999941 },
  { lng: -58.396771465999961, lat: -34.565208421999955 },
  { lng: -58.396742911999979, lat: -34.565358327999945 },
  { lng: -58.396721496999987, lat: -34.565472541999952 },
  { lng: -58.39675718899997, lat: -34.565636724999933 },
  { lng: -58.396807157999945, lat: -34.565758076999941 },
  { lng: -58.396878541999968, lat: -34.565886568999929 },
  { lng: -58.396985615999938, lat: -34.565993643999946 },
  { lng: -58.39704986299995, lat: -34.56603647399993 },
  { lng: -58.397214045999931, lat: -34.566114996999943 },
  { lng: -58.397271026999931, lat: -34.566138738999939 },
  { lng: -58.39738536699997, lat: -34.566186379999976 },
  { lng: -58.397462698999959, lat: -34.566238133999946 },
  { lng: -58.397500770999955, lat: -34.566285721999975 },
  { lng: -58.397443663999979, lat: -34.566457043999947 },
  { lng: -58.397329449999972, lat: -34.566533186999948 },
  { lng: -58.397256875999972, lat: -34.566550437999979 },
  { lng: -58.397171214999958, lat: -34.566586129999962 },
  { lng: -58.397042723999959, lat: -34.566643236999937 },
  { lng: -58.39690709499996, lat: -34.566728896999962 },
  { lng: -58.396785742999953, lat: -34.566778865999936 },
  { lng: -58.396657251999954, lat: -34.566821696999966 },
  { lng: -58.396550175999948, lat: -34.56686452699995 },
  { lng: -58.396443099999942, lat: -34.566993017999948 },
  { lng: -58.396250363999968, lat: -34.56720003099997 },
  { lng: -58.395957689999932, lat: -34.56767830299998 },
  { lng: -58.395814922999932, lat: -34.567842484999971 },
  { lng: -58.395729261999975, lat: -34.568042359999936 },
  { lng: -58.395593632999976, lat: -34.568263649999949 },
  { lng: -58.395393757999955, lat: -34.568549184999938 },
  { lng: -58.395358065999972, lat: -34.568684814999983 },
  { lng: -58.39534378899998, lat: -34.568799028999933 },
  { lng: -58.395308096999941, lat: -34.568891827999948 },
  { lng: -58.395193882999934, lat: -34.56905601099993 },
  { lng: -58.395086807999974, lat: -34.569163085999946 },
  { lng: -58.395001146999959, lat: -34.569227331999969 },
  { lng: -58.394886931999963, lat: -34.569277299999953 },
  { lng: -58.394772718999945, lat: -34.569227331999969 },
  { lng: -58.39471561199997, lat: -34.569177362999937 },
  { lng: -58.394608535999964, lat: -34.569263022999962 },
  { lng: -58.392946472999938, lat: -34.572020183999939 },
  { lng: -58.392548369999986, lat: -34.572245850999934 },
  { lng: -58.390171019999968, lat: -34.573593462999952 },
  { lng: -58.389791214999946, lat: -34.573808755999949 },
  { lng: -58.385365509999986, lat: -34.576317489999951 },
  { lng: -58.384949382999935, lat: -34.576283645999979 },
  { lng: -58.384900334999941, lat: -34.576322883999978 },
  { lng: -58.384286433999932, lat: -34.576280053999938 },
  { lng: -58.383936652999978, lat: -34.576244360999965 },
  { lng: -58.383415550999985, lat: -34.576172977999931 },
  { lng: -58.382858756999951, lat: -34.575623322999945 },
  { lng: -58.382858756999951, lat: -34.575523385999929 },
  { lng: -58.382908724999936, lat: -34.575394894999931 },
  { lng: -58.383065769999973, lat: -34.575309233999974 },
  { lng: -58.383956050999984, lat: -34.574811173999933 },
  { lng: -58.384086558999968, lat: -34.57473816199996 },
  { lng: -58.385207284999979, lat: -34.57411712399994 },
  { lng: -58.385443329999987, lat: -34.573984970999959 },
  { lng: -58.387234585999977, lat: -34.572982120999939 },
  { lng: -58.389543054999933, lat: -34.57161612699997 },
  { lng: -58.389997139999934, lat: -34.571347430999936 },
  { lng: -58.390801500999942, lat: -34.570903646999966 },
  { lng: -58.391032205999977, lat: -34.570776360999957 },
  { lng: -58.391267772999981, lat: -34.570662145999961 },
  { lng: -58.391317740999966, lat: -34.570533655999952 },
  { lng: -58.391296325999974, lat: -34.570376610999972 },
  { lng: -58.391182110999978, lat: -34.570169596999961 },
  { lng: -58.391060759999959, lat: -34.57001969099997 },
  { lng: -58.390868022999939, lat: -34.569848369999931 },
  { lng: -58.390789500999972, lat: -34.569784125999945 },
  { lng: -58.39078266599995, lat: -34.569776211999965 },
  { lng: -58.390687380999964, lat: -34.569665880999935 },
  { lng: -58.390653871999973, lat: -34.569627080999965 },
  { lng: -58.390518241999985, lat: -34.569412928999952 },
  { lng: -58.390439719999961, lat: -34.569341545999976 },
  { lng: -58.390354059999936, lat: -34.569298715999935 },
  { lng: -58.390254121999988, lat: -34.569277299999953 },
  { lng: -58.390054247999956, lat: -34.569255883999972 },
  { lng: -58.389868649999983, lat: -34.56924160899996 },
  { lng: -58.389765470999976, lat: -34.569233830999963 },
  { lng: -58.384186496999973, lat: -34.568813305999981 },
  { lng: -58.384065143999976, lat: -34.568741921999958 },
  { lng: -58.384002772999963, lat: -34.568706993999967 },
  { lng: -58.383886684999936, lat: -34.568641983999953 },
  { lng: -58.383643979999931, lat: -34.568556322999939 },
  { lng: -58.38332275199997, lat: -34.568449246999933 },
  { lng: -58.382951555999966, lat: -34.568413555999939 },
  { lng: -58.382666020999977, lat: -34.568399277999958 },
  { lng: -58.382294824999974, lat: -34.568385002999946 },
  { lng: -58.381795137999973, lat: -34.568356448999964 },
  { lng: -58.38158098699995, lat: -34.568327895999971 },
  { lng: -58.381416803999969, lat: -34.568342170999983 },
  { lng: -58.381324004999954, lat: -34.568434970999931 },
  { lng: -58.38113840699998, lat: -34.568499215999964 },
  { lng: -58.381107756999938, lat: -34.568518078999944 },
  { lng: -58.381045607999965, lat: -34.568556322999939 },
  { lng: -58.381002001999946, lat: -34.568606638999938 },
  { lng: -58.38095280899995, lat: -34.568663398999945 },
  { lng: -58.380895701999975, lat: -34.568770473999962 },
  { lng: -58.380845732999944, lat: -34.56891324299994 },
  { lng: -58.380817179999951, lat: -34.56906314899993 },
  { lng: -58.380767210999977, lat: -34.569184500999938 },
  { lng: -58.380760072999976, lat: -34.569270161999953 },
  { lng: -58.380738657999984, lat: -34.569398652999951 },
  { lng: -58.380731518999937, lat: -34.569527142999959 },
  { lng: -58.380738657999984, lat: -34.56968418699995 },
  { lng: -58.380731518999937, lat: -34.56986978599997 },
  { lng: -58.380719172999932, lat: -34.570196973999941 },
  { lng: -58.380717242999935, lat: -34.570248120999963 },
  { lng: -58.380717242999935, lat: -34.570369472999971 },
  { lng: -58.380717242999935, lat: -34.57049796299998 },
  { lng: -58.380702964999955, lat: -34.570626454999967 },
  { lng: -58.380695826999954, lat: -34.570783498999958 },
  { lng: -58.38065299699997, lat: -34.57094768199994 },
  { lng: -58.380538782999963, lat: -34.571076172999938 },
  { lng: -58.380074787999945, lat: -34.571304599999962 },
  { lng: -58.379546547999951, lat: -34.571604412999932 },
  { lng: -58.379153936999955, lat: -34.571804287999953 },
  { lng: -58.378757705999988, lat: -34.572012988999973 },
  { lng: -58.378218807999986, lat: -34.572296835999964 },
  { lng: -58.378186364999976, lat: -34.572541961999946 },
  { lng: -58.378174981999962, lat: -34.572627970999974 },
  { lng: -58.378154562999953, lat: -34.572782246999964 },
  { lng: -58.38031749299995, lat: -34.572960704999957 },
  { lng: -58.382147664999934, lat: -34.573088576999965 },
  { lng: -58.383586871999967, lat: -34.573189132999971 },
  { lng: -58.383586871999967, lat: -34.573389007999936 },
  { lng: -58.381795137999973, lat: -34.574395520999929 },
  { lng: -58.381663926999977, lat: -34.574384033999934 },
  { lng: -58.379675038999949, lat: -34.574209921999966 },
  { lng: -58.379269011999952, lat: -34.574182271999973 },
  { lng: -58.377683429999934, lat: -34.574074293999956 },
  { lng: -58.375520499999936, lat: -34.573917248999976 },
  { lng: -58.372458132999952, lat: -34.575637599999936 },
  { lng: -58.370773474999964, lat: -34.576622695999959 },
  { lng: -58.370759197999973, lat: -34.577079552999976 },
  { lng: -58.37243671799996, lat: -34.577222320999965 },
  { lng: -58.372700836999968, lat: -34.577250873999958 },
  { lng: -58.376048739999987, lat: -34.577486439999973 },
  { lng: -58.376098708999962, lat: -34.577522132999945 },
  { lng: -58.376063016999979, lat: -34.577693452999938 },
  { lng: -58.375834588999965, lat: -34.577850497999975 },
  { lng: -58.374342665999961, lat: -34.578714241999933 },
  { lng: -58.37404449, lat: -34.578714241999933 },
  { lng: -58.373871532999942, lat: -34.578714242999979 },
  { lng: -58.370313492999969, lat: -34.578425523999954 },
  { lng: -58.367889567999953, lat: -34.578228831999979 },
  { lng: -58.367160212999977, lat: -34.578625924999983 },
  { lng: -58.36584953299996, lat: -34.579339517999983 },
  { lng: -58.365319749999969, lat: -34.579627954999978 },
  { lng: -58.365294984999935, lat: -34.579811219999954 },
  { lng: -58.365265436999948, lat: -34.580029877999948 },
  { lng: -58.365248366999936, lat: -34.580156195999962 },
  { lng: -58.36533402699996, lat: -34.580170471999963 },
  { lng: -58.369488565999973, lat: -34.580513114999974 },
  { lng: -58.369556429999932, lat: -34.580517780999969 },
  { lng: -58.370630706999975, lat: -34.580591636999941 },
  { lng: -58.370623568999974, lat: -34.580820065999944 },
  { lng: -58.369038847999946, lat: -34.581740916999934 },
  { lng: -58.36576946699995, lat: -34.581483934999937 },
  { lng: -58.362325277999958, lat: -34.581210303999967 },
  { lng: -58.361636344999965, lat: -34.581155569999964 },
  { lng: -58.361577243999932, lat: -34.581641710999975 },
  { lng: -58.361415053999963, lat: -34.582975856999951 },
  { lng: -58.362430085999961, lat: -34.583053086999939 },
  { lng: -58.363355632999969, lat: -34.58312351 },
  { lng: -58.366012173999934, lat: -34.583325637999963 },
  { lng: -58.366154940999934, lat: -34.583332775999963 },
  { lng: -58.366162079999981, lat: -34.583532650999985 },
  { lng: -58.364944585999979, lat: -34.584507730999974 },
  { lng: -58.359908855999947, lat: -34.584117998999943 },
  { lng: -58.359689302999982, lat: -34.585764647999952 },
  { lng: -58.359666150999942, lat: -34.58593828599993 },
  { lng: -58.363281192999978, lat: -34.586201080999956 },
  { lng: -58.363692198999956, lat: -34.586230958999977 },
  { lng: -58.363556569999957, lat: -34.587480175999929 },
  { lng: -58.359587627999986, lat: -34.587173226999937 },
  { lng: -58.359473414999968, lat: -34.588086939999982 },
  { lng: -58.359559074999936, lat: -34.588094077999983 },
  { lng: -58.359573351999984, lat: -34.588129769999966 },
  { lng: -58.359590251999975, lat: -34.588186104999977 },
  { lng: -58.359616181999968, lat: -34.588272536999966 },
  { lng: -58.35963759699996, lat: -34.588379612999972 },
  { lng: -58.359773226999948, lat: -34.588415304999955 },
  { lng: -58.360344295999937, lat: -34.588543794999964 },
  { lng: -58.363940852999974, lat: -34.58927607499993 },
  { lng: -58.36718431099996, lat: -34.589890809999929 },
  { lng: -58.367895516999965, lat: -34.590025605999983 },
  { lng: -58.367924069999958, lat: -34.590139819999933 },
  { lng: -58.367874101999973, lat: -34.590339693999965 },
  { lng: -58.367816993999952, lat: -34.590425353999933 },
  { lng: -58.367674226999952, lat: -34.590525291999938 },
  { lng: -58.367545735999954, lat: -34.590603814999952 },
  { lng: -58.367481490999978, lat: -34.590618090999953 },
  { lng: -58.367281614999968, lat: -34.590625229999944 },
  { lng: -58.367110294999975, lat: -34.590618090999953 },
  { lng: -58.36686759, lat: -34.59068947399993 },
  { lng: -58.366724821999981, lat: -34.590739442999961 },
  { lng: -58.36668199199994, lat: -34.590796549999936 },
  { lng: -58.366639159999977, lat: -34.590825103999975 },
  { lng: -58.365325698999982, lat: -34.592716775999975 },
  { lng: -58.364362016999962, lat: -34.594194419999951 },
  { lng: -58.36434774099996, lat: -34.594258666999963 },
  { lng: -58.364354878999961, lat: -34.594308634999948 },
  { lng: -58.364411985999936, lat: -34.594401432999973 },
  { lng: -58.364590444999976, lat: -34.594472817999929 },
  { lng: -58.364683244999981, lat: -34.594487094999977 },
  { lng: -58.364747489999957, lat: -34.594487094999977 },
  { lng: -58.36478318199994, lat: -34.594465679999985 },
  { lng: -58.364875980999955, lat: -34.59437288099997 },
  { lng: -58.365525573999946, lat: -34.593359229999976 },
  { lng: -58.365911045999951, lat: -34.592802436999932 },
  { lng: -58.366125197999963, lat: -34.592873819999966 },
  { lng: -58.366217996999978, lat: -34.592731051999976 },
  { lng: -58.366210857999931, lat: -34.592709637999974 },
  { lng: -58.366996080999968, lat: -34.591524665999941 },
  { lng: -58.367267338999966, lat: -34.591417589999935 },
  { lng: -58.367331583999942, lat: -34.591417589999935 },
  { lng: -58.367338722999932, lat: -34.591460420999965 },
  { lng: -58.366367901999979, lat: -34.593016587999955 },
  { lng: -58.366924696999945, lat: -34.593230739999967 },
  { lng: -58.367024633999961, lat: -34.59307369499993 },
  { lng: -58.366996080999968, lat: -34.593052278999949 },
  { lng: -58.367474351999931, lat: -34.592245641999966 },
  { lng: -58.367638534999969, lat: -34.592060044999982 },
  { lng: -58.367874101999973, lat: -34.592052905999935 },
  { lng: -58.367902654999966, lat: -34.592102874999966 },
  { lng: -58.367895516999965, lat: -34.592145703999961 },
  { lng: -58.367303030999949, lat: -34.59310224799998 },
  { lng: -58.367188816999942, lat: -34.593280706999963 },
  { lng: -58.367188816999942, lat: -34.593323537999936 },
  { lng: -58.368066837999947, lat: -34.593687595999938 },
  { lng: -58.369130456999983, lat: -34.594051653999941 },
  { lng: -58.368466587999933, lat: -34.595779141999969 },
  { lng: -58.367959761999941, lat: -34.597463799999957 },
  { lng: -58.367924069999958, lat: -34.59753518399998 },
  { lng: -58.363969405999967, lat: -34.597213956999951 },
  { lng: -58.363848053999959, lat: -34.597171126999967 },
  { lng: -58.364404847999936, lat: -34.59549360699998 },
  { lng: -58.364478600999973, lat: -34.595319865999954 },
  { lng: -58.364150235999944, lat: -34.595219927999949 },
  { lng: -58.363850423999963, lat: -34.595262758999979 },
  { lng: -58.363803760999986, lat: -34.595429665999973 },
  { lng: -58.363008093999952, lat: -34.59523420499994 },
  { lng: -58.360303834999968, lat: -34.595042140999965 },
  { lng: -58.360290106999969, lat: -34.59504116599993 },
  { lng: -58.35929039499996, lat: -34.59497016399996 },
  { lng: -58.357982672999981, lat: -34.594877284999939 },
  { lng: -58.356654932999959, lat: -34.594877284999939 },
  { lng: -58.356223635999982, lat: -34.594981630999939 },
  { lng: -58.355769772999963, lat: -34.595091436999951 },
  { lng: -58.355562760999987, lat: -34.595177097999965 },
  { lng: -58.355242379999936, lat: -34.595475535999981 },
  { lng: -58.355078659999947, lat: -34.595628039999951 },
  { lng: -58.355041658999937, lat: -34.595662507999975 },
  { lng: -58.354943060999972, lat: -34.595742452999957 },
  { lng: -58.354900508999947, lat: -34.595776952999984 },
  { lng: -58.354617918999963, lat: -34.596006081999974 },
  { lng: -58.354556207999963, lat: -34.596056117999979 },
  { lng: -58.354513418999943, lat: -34.596090810999954 },
  { lng: -58.354465668999978, lat: -34.596105265999938 },
  { lng: -58.354465397999945, lat: -34.59610534799998 },
  { lng: -58.354017197999951, lat: -34.596241041999974 },
  { lng: -58.353711549999957, lat: -34.596464426999944 },
  { lng: -58.353525950999938, lat: -34.59657150299995 },
  { lng: -58.35325469299994, lat: -34.596757099999934 },
  { lng: -58.35310478699995, lat: -34.596928420999973 },
  { lng: -58.352990571999953, lat: -34.597021220999977 },
  { lng: -58.352940603999969, lat: -34.597121157999936 },
  { lng: -58.352917412999943, lat: -34.597163122999973 },
  { lng: -58.352790697999978, lat: -34.59739241699998 },
  { lng: -58.352655068999979, lat: -34.597613706999937 },
  { lng: -58.352505161999943, lat: -34.597777888999929 },
  { lng: -58.352233903999945, lat: -34.597999177999952 },
  { lng: -58.352098274999946, lat: -34.598063424999964 },
  { lng: -58.351969782999959, lat: -34.59813480899993 },
  { lng: -58.351898400999971, lat: -34.598206191999964 },
  { lng: -58.351777047999974, lat: -34.598341821999952 },
  { lng: -58.351612864999936, lat: -34.598498865999943 },
  { lng: -58.351427266999963, lat: -34.598648770999944 },
  { lng: -58.351327329999947, lat: -34.598720155999956 },
  { lng: -58.351227392999931, lat: -34.598784401999978 },
  { lng: -58.351148869999975, lat: -34.598848646999954 },
  { lng: -58.351084624999942, lat: -34.598920029999931 },
  { lng: -58.351004290999981, lat: -34.598960197999929 },
  { lng: -58.350956133999944, lat: -34.598984275999953 },
  { lng: -58.350799089999953, lat: -34.599027106999984 },
  { lng: -58.350677735999966, lat: -34.599105628999951 },
  { lng: -58.34906992599997, lat: -34.600487896999937 },
  { lng: -58.348782612999969, lat: -34.600729623999939 },
  { lng: -58.34877957499998, lat: -34.600732179999966 },
  { lng: -58.347984081999982, lat: -34.601401461999956 },
  { lng: -58.347188588999984, lat: -34.602070744999935 },
  { lng: -58.347106264999979, lat: -34.602140007999935 },
  { lng: -58.346846794999976, lat: -34.602358310999932 },
  { lng: -58.346694496999987, lat: -34.603114550999976 },
  { lng: -58.346165538999969, lat: -34.605741101999968 },
  { lng: -58.346018742999945, lat: -34.606470019999961 },
  { lng: -58.345663066999975, lat: -34.606872128999953 },
  { lng: -58.345580931999962, lat: -34.606964987999959 },
  { lng: -58.345473855999956, lat: -34.607007818999932 },
  { lng: -58.345331087999966, lat: -34.607079201999966 },
  { lng: -58.345131212999945, lat: -34.607207692999964 },
  { lng: -58.344909923999978, lat: -34.607350459999964 },
  { lng: -58.344717186999958, lat: -34.607514642999945 },
  { lng: -58.344616536999979, lat: -34.607575642999961 },
  { lng: -58.344481620999943, lat: -34.60765741199998 },
  { lng: -58.344317437999962, lat: -34.607743071999948 },
  { lng: -58.34425319199994, lat: -34.607771624999941 },
  { lng: -58.344131839999932, lat: -34.607821593999972 },
  { lng: -58.344053317999965, lat: -34.607878700999947 },
  { lng: -58.343924826999967, lat: -34.607957223999961 },
  { lng: -58.343746366999937, lat: -34.608071437999968 },
  { lng: -58.343689259999962, lat: -34.608135682999944 },
  { lng: -58.34366070699997, lat: -34.608178513999974 },
  { lng: -58.343582183999956, lat: -34.608207065999977 },
  { lng: -58.34347510799995, lat: -34.608278450999933 },
  { lng: -58.343353755999942, lat: -34.608371248999958 },
  { lng: -58.343232403999934, lat: -34.608449771999972 },
  { lng: -58.343132465999986, lat: -34.608528292999949 },
  { lng: -58.34303252899997, lat: -34.608599677999962 },
  { lng: -58.342968282999948, lat: -34.608663923999984 },
  { lng: -58.342904037999972, lat: -34.608756722999942 },
  { lng: -58.342832653999949, lat: -34.608806689999938 },
  { lng: -58.342739854999934, lat: -34.60887807499995 },
  { lng: -58.342610263999973, lat: -34.608976971999937 },
  { lng: -58.342468596999936, lat: -34.609085087999972 },
  { lng: -58.342412820999982, lat: -34.609125846999973 },
  { lng: -58.342282998999963, lat: -34.609220716999971 },
  { lng: -58.342090261999942, lat: -34.609384898999963 },
  { lng: -58.341897525999968, lat: -34.60951339099995 },
  { lng: -58.341683373999956, lat: -34.60965615799995 },
  { lng: -58.341483499999981, lat: -34.609791787999939 },
  { lng: -58.341383561999976, lat: -34.609884586999954 },
  { lng: -58.341276486999959, lat: -34.610041631999934 },
  { lng: -58.341212240999937, lat: -34.61014156799996 },
  { lng: -58.341162271999963, lat: -34.610220090999974 },
  { lng: -58.341090888999986, lat: -34.610334304999981 },
  { lng: -58.340998089999971, lat: -34.610391411999956 },
  { lng: -58.340905290999956, lat: -34.61047707299997 },
  { lng: -58.340841044999934, lat: -34.610605563999968 },
  { lng: -58.340791076999949, lat: -34.610691223999936 },
  { lng: -58.340741107999975, lat: -34.610819714999934 },
  { lng: -58.340691138999944, lat: -34.611026727999956 },
  { lng: -58.340591201999985, lat: -34.611433614999953 },
  { lng: -58.340541232999954, lat: -34.611654904999966 },
  { lng: -58.34047077799994, lat: -34.611888286999942 },
  { lng: -58.340427018999947, lat: -34.61203323899997 },
  { lng: -58.34035563499998, lat: -34.61222597699998 },
  { lng: -58.340305665999949, lat: -34.612354467999978 },
  { lng: -58.340269974999956, lat: -34.612497234999978 },
  { lng: -58.340234282999972, lat: -34.612611447999939 },
  { lng: -58.340212867999981, lat: -34.612739939999983 },
  { lng: -58.340162898999949, lat: -34.612889844999984 },
  { lng: -58.340120068999965, lat: -34.613018336999971 },
  { lng: -58.340077237999935, lat: -34.61314682699998 },
  { lng: -58.340055822999943, lat: -34.613268180999967 },
  { lng: -58.340048684999942, lat: -34.613375254999937 },
  { lng: -58.34002013099996, lat: -34.613503746999982 },
  { lng: -58.339984438999977, lat: -34.613653652999972 },
  { lng: -58.339955885999984, lat: -34.613789281999971 },
  { lng: -58.339918780999938, lat: -34.613964690999978 },
  { lng: -58.33987736399996, lat: -34.614160478999963 },
  { lng: -58.339834532999987, lat: -34.614338936999957 },
  { lng: -58.339827394999986, lat: -34.614517397999975 },
  { lng: -58.339820255999939, lat: -34.614660163999929 },
  { lng: -58.339798840999947, lat: -34.614760101999934 },
  { lng: -58.339788339999984, lat: -34.614823108999929 },
  { lng: -58.339784564999945, lat: -34.614845762999948 },
  { lng: -58.33978528199998, lat: -34.614856520999979 },
  { lng: -58.339791702999946, lat: -34.614952838999955 },
  { lng: -58.339784564999945, lat: -34.615081328999963 },
  { lng: -58.339777425999955, lat: -34.615209820999951 },
  { lng: -58.339770286999965, lat: -34.615409694999983 },
  { lng: -58.339770286999965, lat: -34.615538185999981 },
  { lng: -58.339784564999945, lat: -34.615573876999974 },
  { lng: -58.339777425999955, lat: -34.615723783999954 },
  { lng: -58.339784564999945, lat: -34.615852274999952 },
  { lng: -58.339784564999945, lat: -34.61598790499994 },
  { lng: -58.339798840999947, lat: -34.616109255999959 },
  { lng: -58.339799246999974, lat: -34.616110675999948 },
  { lng: -58.339827394999986, lat: -34.616209192999975 },
  { lng: -58.339881009999942, lat: -34.61627353199998 },
  { lng: -58.340879106999978, lat: -34.616963441999928 },
  { lng: -58.341270245999965, lat: -34.617025200999933 },
  { lng: -58.341692882999951, lat: -34.617091933999973 },
  { lng: -58.342470076999973, lat: -34.617091933999973 },
  { lng: -58.342712584999958, lat: -34.617091933999973 },
  { lng: -58.342777916999978, lat: -34.617091933999973 },
  { lng: -58.343677352999975, lat: -34.617220423999981 },
  { lng: -58.34428438499998, lat: -34.617379273999973 },
  { lng: -58.345204966999972, lat: -34.617620173999967 },
  { lng: -58.345209588999978, lat: -34.617711459999953 },
  { lng: -58.345262073999947, lat: -34.618748038999968 },
  { lng: -58.344605342999955, lat: -34.618962189999934 },
  { lng: -58.343250891999958, lat: -34.61864292599995 },
  { lng: -58.342710237999938, lat: -34.618515486999968 },
  { lng: -58.342606595999939, lat: -34.618491056999972 },
  { lng: -58.3413502399999, lat: -34.6184339499999 },
  { lng: -58.341032737999967, lat: -34.618458690999944 },
  { lng: -58.340250928999978, lat: -34.618519609999964 },
  { lng: -58.338894635999964, lat: -34.618519609999964 },
  { lng: -58.338366395999969, lat: -34.618705208999984 },
  { lng: -58.338165256999957, lat: -34.618919321999954 },
  { lng: -58.338005009999961, lat: -34.619089909999957 },
  { lng: -58.337923815999943, lat: -34.619176341999946 },
  { lng: -58.337652557999945, lat: -34.619676028999947 },
  { lng: -58.337631155999986, lat: -34.619789153999932 },
  { lng: -58.3375526199999, lat: -34.620204268999942 },
  { lng: -58.337441240999965, lat: -34.62054636199997 },
  { lng: -58.337352745999965, lat: -34.6208181699999 },
  { lng: -58.337024379999946, lat: -34.621289302999969 },
  { lng: -58.336867335999955, lat: -34.621788988999981 },
  { lng: -58.336902355999939, lat: -34.62199035499998 },
  { lng: -58.33695778699996, lat: -34.622309084999983 },
  { lng: -58.336981549999962, lat: -34.622445719999973 },
  { lng: -58.337155719999942, lat: -34.622572389999959 },
  { lng: -58.337452682999981, lat: -34.622788363999973 },
  { lng: -58.33808086099998, lat: -34.622845470999948 },
  { lng: -58.339068591999933, lat: -34.62271435599996 },
  { lng: -58.339694134999945, lat: -34.622631318999936 },
  { lng: -58.340422249999961, lat: -34.622774086999982 },
  { lng: -58.340336589999936, lat: -34.623159559999976 },
  { lng: -58.339828584999964, lat: -34.623440969999933 },
  { lng: -58.339692954999975, lat: -34.623583738999969 },
  { lng: -58.339543048999985, lat: -34.623719367999968 },
  { lng: -58.339407419999986, lat: -34.623833581999975 },
  { lng: -58.339286066999932, lat: -34.62393352 },
  { lng: -58.339136160999942, lat: -34.624076285999934 },
  { lng: -58.338979116999951, lat: -34.624204777999978 },
  { lng: -58.338850624999964, lat: -34.624297575999947 },
  { lng: -58.338700719999963, lat: -34.624454620999984 },
  { lng: -58.338565090999964, lat: -34.624575973999981 },
  { lng: -58.33848656899994, lat: -34.624654495999948 },
  { lng: -58.338393769999982, lat: -34.624683049999931 },
  { lng: -58.338272416999985, lat: -34.624725878999982 },
  { lng: -58.338201032999962, lat: -34.624768710999945 },
  { lng: -58.337665654999967, lat: -34.624882923999962 },
  { lng: -58.337494332999938, lat: -34.624904339999944 },
  { lng: -58.337387257999978, lat: -34.624932892999936 },
  { lng: -58.33721593599995, lat: -34.624947168999938 },
  { lng: -58.33706603, lat: -34.624968584999976 },
  { lng: -58.336958954999943, lat: -34.625039968999943 },
  { lng: -58.33599527299998, lat: -34.625746667999977 },
  { lng: -58.335845366999934, lat: -34.625818052999932 },
  { lng: -58.335731151999937, lat: -34.625925128999938 },
  { lng: -58.335724013999936, lat: -34.625989373999971 },
  { lng: -58.335645491999969, lat: -34.626082172999929 },
  { lng: -58.335524139999961, lat: -34.626160694999953 },
  { lng: -58.335359847999939, lat: -34.626297603999944 },
  { lng: -58.335352817999933, lat: -34.626303462999942 },
  { lng: -58.335231465999982, lat: -34.626410538999949 },
  { lng: -58.335188635999941, lat: -34.626517613999965 },
  { lng: -58.335188635999941, lat: -34.626631828999962 },
  { lng: -58.335195772999953, lat: -34.626796010999954 },
  { lng: -58.335188635999941, lat: -34.62690308699996 },
  { lng: -58.335145804999968, lat: -34.626988746999984 },
  { lng: -58.335145804999968, lat: -34.627067269999941 },
  { lng: -58.335195772999953, lat: -34.627160068999956 },
  { lng: -58.335309987999949, lat: -34.627267144999962 },
  { lng: -58.33595958099994, lat: -34.627831076999939 },
  { lng: -58.336212576999969, lat: -34.628027850999956 },
  { lng: -58.336153496999941, lat: -34.628227810999931 },
  { lng: -58.336366227999974, lat: -34.628277920999949 },
  { lng: -58.336964130999945, lat: -34.628418760999978 },
  { lng: -58.338222856999948, lat: -34.628715259999979 },
  { lng: -58.338590674999978, lat: -34.628801901999964 },
  { lng: -58.338939799999935, lat: -34.628884139999968 },
  { lng: -58.339365769999972, lat: -34.628984479999929 },
  { lng: -58.339835610999955, lat: -34.627888182999982 },
  { lng: -58.339836902999934, lat: -34.627885168999967 },
  { lng: -58.33985398599998, lat: -34.627888182999982 },
  { lng: -58.339921851999975, lat: -34.627900159999967 },
  { lng: -58.340322312999945, lat: -34.627970828999935 },
  { lng: -58.34246382799995, lat: -34.626157678999959 },
  { lng: -58.344219868999971, lat: -34.626343277999979 },
  { lng: -58.344262700999934, lat: -34.626571705999936 },
  { lng: -58.341362845999981, lat: -34.628950712999938 },
  { lng: -58.341321686999947, lat: -34.628984479999929 },
  { lng: -58.341424287999985, lat: -34.629009482999948 },
  { lng: -58.342384058999983, lat: -34.629243376999966 },
  { lng: -58.342747223999936, lat: -34.629331879999938 },
  { lng: -58.342892173999985, lat: -34.629367203999948 },
  { lng: -58.343020621999983, lat: -34.629398505999973 },
  { lng: -58.343269284999963, lat: -34.62925161499993 },
  { lng: -58.343398773999979, lat: -34.629145668999968 },
  { lng: -58.344525640999962, lat: -34.628223686999945 },
  { lng: -58.344559216999983, lat: -34.628223686999945 },
  { lng: -58.344739791999984, lat: -34.628223686999945 },
  { lng: -58.345325139999943, lat: -34.628666267999961 },
  { lng: -58.343101341999954, lat: -34.630238469999938 },
  { lng: -58.345153401999937, lat: -34.632265522999944 },
  { lng: -58.345329860999982, lat: -34.632339821999949 },
  { lng: -58.345345201999976, lat: -34.632346280999968 },
  { lng: -58.347414629999946, lat: -34.633217618999936 },
  { lng: -58.347972888999948, lat: -34.633452674999944 },
  { lng: -58.349674378999964, lat: -34.634169091999979 },
  { lng: -58.350122051999961, lat: -34.634415311999931 },
  { lng: -58.350227002999986, lat: -34.634473034999928 },
  { lng: -58.350310697999987, lat: -34.634519067999975 },
  { lng: -58.35110273, lat: -34.634954685999958 },
  { lng: -58.3520538399999, lat: -34.635477795999975 },
  { lng: -58.354255319999936, lat: -34.637187979999965 },
  { lng: -58.355871539999953, lat: -34.638160389999939 },
  { lng: -58.357050707999974, lat: -34.639403906999974 },
  { lng: -58.357115152999938, lat: -34.639494129999946 },
  { lng: -58.357228169999985, lat: -34.639652352999974 },
  { lng: -58.357645571999967, lat: -34.640236717999983 },
  { lng: -58.35762452299997, lat: -34.640510355999936 },
  { lng: -58.357610733999934, lat: -34.640689614999928 },
  { lng: -58.357526599999971, lat: -34.641783367999949 },
  { lng: -58.357101145999934, lat: -34.642705182999975 },
  { lng: -58.357035268999937, lat: -34.642847915999937 },
  { lng: -58.356897814999968, lat: -34.643145732999983 },
  { lng: -58.356812759999968, lat: -34.643330019999951 },
  { lng: -58.356622148999975, lat: -34.644523159999949 },
  { lng: -58.357306980999965, lat: -34.645256912999969 },
  { lng: -58.357403237999961, lat: -34.645360045999951 },
  { lng: -58.357454956999959, lat: -34.645415459999981 },
  { lng: -58.357507106999947, lat: -34.64543952899993 },
  { lng: -58.358077837999986, lat: -34.645702943999936 },
  { lng: -58.359001606999982, lat: -34.646129299999984 },
  { lng: -58.359264406999955, lat: -34.646304498999939 },
  { lng: -58.360429279999948, lat: -34.647081080999953 },
  { lng: -58.361619010999959, lat: -34.648211329999981 },
  { lng: -58.362790430999951, lat: -34.648601799999938 },
  { lng: -58.362868230999936, lat: -34.648627731999966 },
  { lng: -58.363147466999976, lat: -34.64865565599996 },
  { lng: -58.364057959999968, lat: -34.648746708999965 },
  { lng: -58.364398970999957, lat: -34.648976191999964 },
  { lng: -58.36443152399994, lat: -34.648998099999972 },
  { lng: -58.365008124999974, lat: -34.649386126999957 },
  { lng: -58.365378820999979, lat: -34.649635588999956 },
  { lng: -58.366688555999986, lat: -34.650240081999982 },
  { lng: -58.366925470999945, lat: -34.650349426999981 },
  { lng: -58.367825068999935, lat: -34.650786875999984 },
  { lng: -58.368357498999956, lat: -34.651045780999937 },
  { lng: -58.368400479999934, lat: -34.651066679999929 },
  { lng: -58.369185959999982, lat: -34.651896078999982 },
  { lng: -58.369185959999982, lat: -34.653204779999953 },
  { lng: -58.369526780999934, lat: -34.653801220999981 },
  { lng: -58.369649932999948, lat: -34.654016734999971 },
  { lng: -58.369661850999933, lat: -34.654037590999963 },
  { lng: -58.369861155999956, lat: -34.654148316999965 },
  { lng: -58.370732607999969, lat: -34.654632456999934 },
  { lng: -58.371028267999975, lat: -34.654794694999964 },
  { lng: -58.371078130999933, lat: -34.654822056999933 },
  { lng: -58.372148129999971, lat: -34.655409198999962 },
  { lng: -58.373099909999951, lat: -34.656420469999944 },
  { lng: -58.373584927999957, lat: -34.656814542999939 },
  { lng: -58.37405169699997, lat: -34.65719379199993 },
  { lng: -58.375717319999978, lat: -34.65719379199993 },
  { lng: -58.376277233999986, lat: -34.657242480999969 },
  { lng: -58.37650329, lat: -34.657262137999965 },
  { lng: -58.37650636799998, lat: -34.657262405999973 },
  { lng: -58.377085509999972, lat: -34.657312765999961 },
  { lng: -58.377795035999952, lat: -34.65746480699994 },
  { lng: -58.378751131999934, lat: -34.657669682999938 },
  { lng: -58.380464694999944, lat: -34.657821540999976 },
  { lng: -58.380726342999935, lat: -34.657844728999976 },
  { lng: -58.381267693999973, lat: -34.657844728999976 },
  { lng: -58.38126772399994, lat: -34.657844729999965 },
  { lng: -58.382391968999968, lat: -34.657844729999965 },
  { lng: -58.383819639999956, lat: -34.657844729999965 },
  { lng: -58.384554729999934, lat: -34.657986178999977 },
  { lng: -58.385247319999962, lat: -34.658201649999967 },
  { lng: -58.385736884999972, lat: -34.658566797999981 },
  { lng: -58.386182839999947, lat: -34.658899419999955 },
  { lng: -58.386824569999987, lat: -34.659665359999963 },
  { lng: -58.387233193999975, lat: -34.660128782999948 },
  { lng: -58.387303439999982, lat: -34.660208449999971 },
  { lng: -58.387430658999961, lat: -34.660352730999932 },
  { lng: -58.387469202999966, lat: -34.66037509399996 },
  { lng: -58.387469231999944, lat: -34.660375108999972 },
  { lng: -58.387989200999982, lat: -34.66067678 },
  { lng: -58.388420879999956, lat: -34.660793988999956 },
  { lng: -58.388744869999982, lat: -34.660881959999983 },
  { lng: -58.388746178999952, lat: -34.660882270999934 },
  { lng: -58.389690926999947, lat: -34.661106760999928 },
  { lng: -58.390100316999963, lat: -34.661204039999973 },
  { lng: -58.390484839999942, lat: -34.66129541 },
  { lng: -58.390888898999947, lat: -34.661845299999982 },
  { lng: -58.391768309999975, lat: -34.662405000999968 },
  { lng: -58.392730465999932, lat: -34.662666551999962 },
  { lng: -58.392972250999946, lat: -34.662652507999951 },
  { lng: -58.39359262399995, lat: -34.662616472999957 },
  { lng: -58.393755574999943, lat: -34.662607007999952 },
  { lng: -58.393813379999983, lat: -34.662603649999937 },
  { lng: -58.39553553899998, lat: -34.66222825899996 },
  { lng: -58.395978611999965, lat: -34.662250853999979 },
  { lng: -58.396463478999976, lat: -34.66227558099996 },
  { lng: -58.397496389999958, lat: -34.662188979999939 },
  { lng: -58.397621173999937, lat: -34.662060098999973 },
  { lng: -58.397971749999954, lat: -34.661698009999952 },
  { lng: -58.398898700999951, lat: -34.661157939999953 },
  { lng: -58.39998843099994, lat: -34.661040122999964 },
  { lng: -58.400170289999949, lat: -34.661020460999964 },
  { lng: -58.400429645999964, lat: -34.660855268999967 },
  { lng: -58.400429699999961, lat: -34.660855234999929 },
  { lng: -58.400740719999988, lat: -34.660657139999955 },
  { lng: -58.4019647699999, lat: -34.659959949999973 },
  { lng: -58.402285032999941, lat: -34.659912777999978 },
  { lng: -58.402351730999953, lat: -34.659902953999961 },
  { lng: -58.402457334999951, lat: -34.659887398999956 },
  { lng: -58.403378550999946, lat: -34.659751710999956 },
  { lng: -58.403465203999986, lat: -34.659766339999976 },
  { lng: -58.403749815999959, lat: -34.659814382999969 },
  { lng: -58.404671101999952, lat: -34.659969898999975 },
  { lng: -58.405472737999958, lat: -34.660105216999966 },
  { lng: -58.405521743999941, lat: -34.660113569999965 },
  { lng: -58.405521775999944, lat: -34.660113576999947 },
  { lng: -58.406558004999965, lat: -34.660290178999958 },
  { lng: -58.406558036999968, lat: -34.660290182999972 },
  { lng: -58.4066946, lat: -34.660313458999951 },
  { lng: -58.406802322999965, lat: -34.660304141999973 },
  { lng: -58.406802351999943, lat: -34.660304141999973 },
  { lng: -58.407096251999974, lat: -34.660278726999934 },
  { lng: -58.40837542099996, lat: -34.660168118999934 },
  { lng: -58.408450855999945, lat: -34.660135498999978 },
  { lng: -58.408618633999936, lat: -34.660062945999982 },
  { lng: -58.409375657999988, lat: -34.659735585999954 },
  { lng: -58.410576421999963, lat: -34.659216332999961 },
  { lng: -58.4118284799999, lat: -34.658869959999947 },
  { lng: -58.413210933999949, lat: -34.658818809999957 },
  { lng: -58.413420930999962, lat: -34.658811039999932 },
  { lng: -58.414152335999972, lat: -34.658957811999983 },
  { lng: -58.414152390999959, lat: -34.65895782299998 },
  { lng: -58.415084689999958, lat: -34.659144910999942 },
  { lng: -58.415793763999943, lat: -34.659344458999954 },
  { lng: -58.4157938, lat: -34.659344468999961 },
  { lng: -58.416724679999959, lat: -34.659606439999948 },
  { lng: -58.418911338999976, lat: -34.660274179999931 },
  { lng: -58.421402970999964, lat: -34.661060416999931 },
  { lng: -58.421560515999943, lat: -34.661138563999941 },
  { lng: -58.422037089999947, lat: -34.661374958999943 },
  { lng: -58.423147046999986, lat: -34.661925531999941 },
  { lng: -58.423672473999943, lat: -34.66218615899993 },
  { lng: -58.423729065999964, lat: -34.662214229999961 },
  { lng: -58.423794589999943, lat: -34.662246729999936 },
  { lng: -58.423831982999957, lat: -34.662277228999983 },
  { lng: -58.423832004999952, lat: -34.662277251999967 },
  { lng: -58.423858604999964, lat: -34.662298955999972 },
  { lng: -58.425642711999956, lat: -34.663754473999973 },
  { lng: -58.425642742999969, lat: -34.663754500999971 },
  { lng: -58.425649558999964, lat: -34.663760060999948 },
  { lng: -58.427420269999971, lat: -34.665507859999934 },
  { lng: -58.437949479999986, lat: -34.678065379999964 },
  { lng: -58.446923904999949, lat: -34.688766605999945 },
  { lng: -58.44692428899998, lat: -34.688767063999933 },
  { lng: -58.450325576999944, lat: -34.692822805999981 },
  { lng: -58.457543343999987, lat: -34.701173997999945 },
  { lng: -58.457543385999941, lat: -34.701174046999938 },
  { lng: -58.458958422999956, lat: -34.702811289999943 },
  { lng: -58.461206441999934, lat: -34.705412321999972 },
  { lng: -58.46136734199996, lat: -34.705291573999943 },
  { lng: -58.461614870999938, lat: -34.705105819999972 },
  { lng: -58.461616766999953, lat: -34.705104395999967 },
  { lng: -58.461724406999963, lat: -34.705023618999974 },
  { lng: -58.473203014999967, lat: -34.696409578999976 },
  { lng: -58.47368275599996, lat: -34.696049560999938 },
  { lng: -58.502419231999966, lat: -34.674484485999983 },
  { lng: -58.528880379999976, lat: -34.654626909999934 },
  { lng: -58.530213328999935, lat: -34.634816542999943 },
  { lng: -58.531358452999939, lat: -34.617797683999981 },
  { lng: -58.531358470999976, lat: -34.617797405999966 },
  { lng: -58.531358472999955, lat: -34.617797377999977 },
  { lng: -58.531358474999934, lat: -34.617797350999979 },
  { lng: -58.531512109999937, lat: -34.615514029999929 },
  { lng: -58.529415958999948, lat: -34.611010132999979 },
  { lng: -58.529412568999987, lat: -34.611002850999967 },
  { lng: -58.523143970999968, lat: -34.597533822999935 },
  { lng: -58.515586240999937, lat: -34.581294895999974 },
  { lng: -58.515585287999954, lat: -34.581292849999954 },
  { lng: -58.512484573999984, lat: -34.574630494999951 },
  { lng: -58.512484547999975, lat: -34.574630436999939 },
  { lng: -58.512484475999941, lat: -34.57463028199993 },
  { lng: -58.509959635999962, lat: -34.569205279999949 },
  { lng: -58.509958041999937, lat: -34.56920185599995 },
  { lng: -58.509958027999971, lat: -34.569201828999951 },
  { lng: -58.500770149999937, lat: -34.549460279999948 },
  { lng: -58.499147389999962, lat: -34.548760368999979 },
  { lng: -58.475865975999966, lat: -34.538718864999964 },
  { lng: -58.463531588999956, lat: -34.533398919999968 },
  { lng: -58.463486079999939, lat: -34.533333279999965 },
  { lng: -58.460250882999958, lat: -34.528666587999965 },
  { lng: -58.459575900999937, lat: -34.527692942999977 },
  { lng: -58.459567830999958, lat: -34.527755098999933 },
  { lng: -58.459564092999983, lat: -34.527783904999978 },
  { lng: -58.459563570999933, lat: -34.527782963999982 },
  { lng: -58.459475986999962, lat: -34.527615757999968 },
  { lng: -58.459420553999962, lat: -34.52750993199993 },
  { lng: -58.459348310999985, lat: -34.527423239999962 },
  { lng: -58.459277435999979, lat: -34.527338190999956 },
  { lng: -58.459188433999941, lat: -34.5272313899999 },
  { lng: -58.459133160999954, lat: -34.527165059999959 },
  { lng: -58.459066538999934, lat: -34.527085113999931 },
  { lng: -58.459029073999943, lat: -34.527040154999952 },
  { lng: -58.458928405999984, lat: -34.526985244999935 },
  { lng: -58.458746906999977, lat: -34.526896719999968 },
  { lng: -58.458497063999971, lat: -34.526746813999978 },
  { lng: -58.458347157999981, lat: -34.526668291999954 },
  { lng: -58.458111590999977, lat: -34.52662546199997 },
  { lng: -58.457918854999946, lat: -34.526568354999938 },
  { lng: -58.457747533999964, lat: -34.526539799999966 },
  { lng: -58.457476274999976, lat: -34.526525524999954 },
  { lng: -58.457340645999977, lat: -34.526546938999957 },
  { lng: -58.457069386999933, lat: -34.526611184999979 },
  { lng: -58.456798128999935, lat: -34.526718260999928 },
  { lng: -58.456662498999947, lat: -34.526782505999961 },
  { lng: -58.456455485999982, lat: -34.52691813499996 },
  { lng: -58.456191365999985, lat: -34.527075178999951 },
  { lng: -58.456189932999962, lat: -34.527076075999958 },
  { lng: -58.455848723999964, lat: -34.527289330999963 },
  { lng: -58.455684540999982, lat: -34.527389268999968 },
  { lng: -58.455548910999937, lat: -34.527489205999984 },
  { lng: -58.455463250999969, lat: -34.527631973999974 },
  { lng: -58.455350887999941, lat: -34.52776287599994 }
];
